import React from 'react';
import './App.css';
import Menu from './components/NavigationBar';
import MenuMobile from './components/NavigationMobil';
import About from './components/about';
import Contact from './components/contact';
import Services from './components/services';
import Footer from './components/footer';
import {useMediaQuery} from '@material-ui/core';



function App() {
    const isActive = useMediaQuery("(min-width: 850px)");
    const isMobile = useMediaQuery("(max-width: 850px)");
  return(
    <div className ="App">
     {isActive && < Menu />}  
      { isMobile && <MenuMobile /> }
      <About />
      <Services />
      <Contact />
      <Footer />
     </div>
  )
 
}

export default App;
